import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import { moveArticleProperty, saveArticleProperty } from "@ext/properties/logic/saveArticleProperties";
import { useCallback } from "react";

export const useUpdateViewArticle = () => {
	const apiUrlCreator = ApiUrlCreatorService.value;

	// biome-ignore lint/correctness/useExhaustiveDependencies: apiUrlCreator is context
	return useCallback(
		(articlePath: string, property: string, value: string, isDelete?: boolean, moveFrom?: string | null) => {
			if (moveFrom !== undefined) {
				void moveArticleProperty(
					apiUrlCreator,
					articlePath,
					property,
					moveFrom,
					isDelete || !value ? null : value,
				);
				return;
			}

			void saveArticleProperty(apiUrlCreator, articlePath, property, value, isDelete);
		},
		[apiUrlCreator],
	);
};
